import { ApolloClient, InMemoryCache, split } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { createUploadLink } from "apollo-upload-client";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import axios from "axios";
import { getMainDefinition } from "@apollo/client/utilities";
import { onError } from "@apollo/client/link/error";
import { errorMessage } from "utils/errorMessage";

const sha512 = require("js-sha512");

export const enableLog = false;
export const enableConsole = true;
export const puestosConAcceso = ["0", "1", "3"];
export const adminKey = sha512("al3d3sm4");
const subscriptionsEnv = process.env.REACT_APP_ENABLE_SUBSCRIPTIONS;
export const enableSubscriptions =
  subscriptionsEnv === "true" || (!subscriptionsEnv && process.env.NODE_ENV === "production");

export const API_URL = `${process.env.REACT_APP_HTPPROTOCOL}://${process.env.REACT_APP_DOMAIN}`;

const GRAPHQL_URL = `${API_URL}/graphql`;
const WS_URL = `${process.env.REACT_APP_WSPROTOCOL}://${process.env.REACT_APP_DOMAIN}/subscriptions`;

const httpLink = createUploadLink({
  uri: GRAPHQL_URL,
});

const wsLink = enableSubscriptions
  ? new GraphQLWsLink(
      createClient({
        url: WS_URL,
        retryAttempts: 0,
        connectionParams: () => {
          let token = "";
          if (localStorage.getItem("user")) token = JSON.parse(localStorage.getItem("user")).token;
          return {
            Authorization: token,
          };
        },
        on: {
          connected: () => enableConsole && console.log("Connected to GraphQL WS"),
          connecting: () => enableConsole && console.log("Connecting to GraphQL WS"),
          closed: () => enableConsole && console.log("Closed connection to GraphQL WS"),
          error: (error) => enableConsole && console.log("Error on GraphQL WS", error),
        },
      })
    )
  : null;

const authLink = setContext((_, { headers }) => {
  //Get the token from the user in local storage
  let token = "";
  if (localStorage.getItem("user")) token = JSON.parse(localStorage.getItem("user")).token;

  return {
    headers: {
      ...headers,
      authorization: token,
    },
  };
});

// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const httpAuthLink = authLink.concat(httpLink);
const link =
  enableSubscriptions && wsLink
    ? split(
        // split based on operation type
        ({ query }) => {
          const definition = getMainDefinition(query);
          return definition.kind === "OperationDefinition" && definition.operation === "subscription";
        },
        wsLink,
        httpAuthLink
      )
    : httpAuthLink;

export const client = new ApolloClient({
  link: onError(({ graphQLErrors, networkError }) => {
    const message = errorMessage({ graphQLErrors, networkError });
    graphQLErrors?.forEach((error) => { error.message = errorMessage(error); });
    if (networkError) networkError.message = message;
  }).concat(link),
  cache: new InMemoryCache(),
});

axios.interceptors.response.use((response) => response, (error) => {
  error.message = errorMessage(error);
  return Promise.reject(error);
});
